import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'meterReadFormat'
})
export class MeterReadFormatPipe implements PipeTransform {
  transform(value: string | number | null | undefined, readingFormat?: string | null): string {
    if (value === null || value === undefined) {
      return '';
    }

    const rawValue = `${value}`.trim();
    if (!rawValue) {
      return '';
    }

    const parsedFormat = this.parseReadingFormat(readingFormat);
    if (!parsedFormat) {
      return rawValue.replace('.', ',');
    }

    const normalizedValue = rawValue.replace(',', '.');
    if (!/^\d+(\.\d+)?$/.test(normalizedValue)) {
      return rawValue;
    }

    const [integerPart = '', decimalPart = ''] = normalizedValue.split('.');
    if (integerPart.length > parsedFormat.integerDigits || decimalPart.length > parsedFormat.decimalDigits) {
      return rawValue;
    }

    const formattedIntegerPart = integerPart.padStart(parsedFormat.integerDigits, '0');
    if (parsedFormat.decimalDigits === 0) {
      return formattedIntegerPart;
    }

    const formattedDecimalPart = decimalPart.padEnd(parsedFormat.decimalDigits, '0');
    return `${formattedIntegerPart},${formattedDecimalPart}`;
  }

  private parseReadingFormat(format?: string | null): { integerDigits: number; decimalDigits: number } | null {
    if (!format) {
      return null;
    }

    const [integerPart, decimalPart] = format.split(',');
    const integerDigits = Number(integerPart);
    const decimalDigits = Number(decimalPart);

    if (!Number.isFinite(integerDigits) || !Number.isFinite(decimalDigits)) {
      return null;
    }

    if (integerDigits < 1 || decimalDigits < 0) {
      return null;
    }

    return { integerDigits, decimalDigits };
  }
}
